<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Download",
    "description": "Download Bruiloft in je Broekzak"
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single">
  <h1>Dé persoonlijke trouw-app rondom jullie bruiloft</h1>
  <p>
    Alles wat je gasten moeten weten op één plek.<br/>
    Alle onderdelen die je nodig hebt.<br/>
    Helemaal naar jullie eigen smaak.<br/>
  </p>

  <p>Download gelijk de app:</p>
  <div class="app-download-button">
    <a [href]="distributionLinks[deviceOss.Ios]" target="_blank">
      <img src="/assets/images/download-on-the-app-store-small.png" alt="iOS Download"/>
    </a>
  </div>
  <div class="app-download-button">
    <a [href]="distributionLinks[deviceOss.Android]" target="_blank">
      <img src="/assets/images/get-it-on-google-play-small.png" alt="Android Download"/>
    </a>
  </div>
</div>
